import { render, staticRenderFns } from "./PayOnCardReader.vue?vue&type=template&id=25b53948&scoped=true"
import script from "./PayOnCardReader.vue?vue&type=script&lang=js"
export * from "./PayOnCardReader.vue?vue&type=script&lang=js"
import style0 from "./PayOnCardReader.vue?vue&type=style&index=0&id=25b53948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b53948",
  null
  
)

export default component.exports